import { FC, ReactNode } from "react";
import classes from "./ComponentCard.module.less";

interface ComponentCardProps {
    title: string;
    components: Array<{
        title: string;
        component: ReactNode;
    }>;
}

export const ComponentCard: FC<ComponentCardProps> = ({ title, components }) => {
    return (
        <div className={classes.componentCard}>
            <div className={classes.componentHeader}>
                <h3>{title}</h3>
            </div>

            <div className={classes.preview}>
                {components.map(({ title, component }) => (
                    <div className={classes.variant} key="title">
                        <p className={classes.variantLabel}>{title}</p>
                        <div className={classes.variantContent}>{component}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
